<template>
    <BaseCard style="height: 100%;" v-bind="$attrs" card-body-class="pt--10 pb--10">
        <template #card-body>
            <div class="h--auto">
                <div class="flex align-items-center gap-1">
                    <span class="text--sm text--medium text-gray-600">{{ title || "-" }}</span>
                    <BootstrapTooltip :content="tooltipText" placement="right" custom-class="text--xs text--geist-mon">
                        <IconSvg name="info" fill="#4b5563" />
                    </BootstrapTooltip>
                </div>
                <div class="mt--5">
                    <span class="text--md text--bold text--upper text-gray-700">{{ value || 0 }}</span>
                </div>
            </div>
        </template>
    </BaseCard>
</template>

<script>
import { BaseCard } from "@/components/ui/index";
import BootstrapTooltip from "@/components/ui/tooltip/index.vue";
import IconSvg from "../ui/icons/Icon-Svg.vue";

export default {
    name: "ClientListStat",

    components: {
        BaseCard,
        BootstrapTooltip,
        IconSvg,
    },

    props: {
        title: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        tooltipText: {
            type: String,
            default: "",
        },
    },
};
</script>